// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".disableButton{opacity:.5!important;pointer-events:none!important}.closeiocn{right:0!important;position:absolute!important;top:0!important;padding:10px 5px!important;cursor:pointer!important}.loader{border-width:2px;border-bottom-color:#145143;border-left-color:#145143;border-top-color:#fff;border-right-color:#fff;border-radius:50%;margin:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
